export default __webpack_public_path__ + "static/media/1.c0df7bd8.png";